module.exports = __webpack_public_path__ + "static/media/icon_call.4715e925.svg";